import React from "react";
import AttachmentPreviewSkeleton from "./PreviewSkeleton";
import ImagePreview from "./ImagePreview";
import PdfPreview from "./PdfPreview";
import DocPreview from "./DocPreview";
import VideoPreview from "./VideoPreview";
import AudioPreview from "./AudioPreview";
import TextPreview from "./TextPreview";
import { AssetCreateTypeEnum } from "app/components/MediaUploader/types";
import type { TicketAttachmentFile } from "app/containers/Features/containers/Ticket/types";

type AttachmentPreviewViewerProps = {
  fileType?: TicketAttachmentFile["type"];
  fileUrl?: string;
  fileName?: string;
  zoomLevel?: number;
  loading?: boolean;
};

const AttachmentPreviewViewer: React.FC<AttachmentPreviewViewerProps> = ({
  fileType,
  fileUrl,
  fileName,
  zoomLevel = 100,
  loading = false,
}) => {
  if (loading) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  switch (fileType) {
    case AssetCreateTypeEnum.IMAGE:
      return (
        <ImagePreview fileUrl={fileUrl} fileName={fileName} zoomLevel={zoomLevel} />
      );
    case AssetCreateTypeEnum.PDF:
      return (
        <PdfPreview
          fileUrl={fileUrl}
          fileName={fileName}
          zoomLevel={zoomLevel}
          loading={loading}
        />
      );
    case AssetCreateTypeEnum.TEXT:
      return (
        <TextPreview
          fileUrl={fileUrl}
          fileName={fileName}
          zoomLevel={zoomLevel}
        />
      );
    case AssetCreateTypeEnum.DOC:
      return <DocPreview fileUrl={fileUrl} fileName={fileName} />;
    case AssetCreateTypeEnum.VIDEO:
      return (
        <VideoPreview fileUrl={fileUrl} fileName={fileName} zoomLevel={zoomLevel} />
      );
    case AssetCreateTypeEnum.AUDIO:
      return (
        <AudioPreview fileUrl={fileUrl} fileName={fileName} zoomLevel={zoomLevel} />
      );
    default:
      return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }
};

export default AttachmentPreviewViewer;
